export enum PermitObjectOperation {
  CREATE = 'PP-Create',
  RECEIVE = 'PP-Receive',
  SEND = 'PP-Send',
  MODIFY = 'PP-Modify',
  MODIFYED = 'PP-Modifyed',
  REJECT = 'PP-Reject',
  GRANT = 'PP-Grant',
  CHANGE = 'PP-Change',
  CHANGED = 'PP-Changed',
  NOTCHANGED = 'PP-NotChanged',
  EXPIRE = 'PP-Expire',
}

export enum PermitObjectStatus {
  EXPIRED = 'PP-Expired',
  GRANTED = 'PP-Granted',
  CHANGING = 'PP-Changing',
  REVIEW = 'PP-Review',
  NEW = 'PP-New',
  REVISION = 'PP-Revision',
  RECEIVED = 'PP-Received',
  REJECTED = 'PP-Rejected',
}

export const IS_NEW_CODE = 'isNew';
